import { ca } from '@cian/analytics';

export interface IPageExtra {
  review_id?: string;
  question_id?: string;
}

export interface IPage {
  dealType?: string | null;
  objectType?: string | null;
  offerID?: number;
  offerPhone?: string;
  pageType?: string;
  siteType?: string;
  extra: IPageExtra;
}

export function trackOpenThread(page: IPage) {
  ca('eventSite', {
    action: 'click_sopr',
    category: 'NewbuildingReviews',
    label: 'thred',
    name: 'oldevent',
    page: page as unknown as Record<string, unknown>,
  });
}
